<template>
  <span>
    <v-img
      :src="src"
      class="image grey lighten-2"
      :width="width"
      :height="height"
      v-on:click="show"
    ></v-img>
    <CommonDialog
      :dialog="dialogFilePreview"
      :on-cancel="() => (dialogFilePreview = false)"
      with-out-confirm
    >
      <div class="image-container">
        <img :src="src" alt="" />
      </div>
    </CommonDialog>
  </span>
</template>

<script>
import CommonDialog from "../../dialogs/CommonDialog";
export default {
  components: { CommonDialog },
  name: "ImageItem",
  props: {
    src: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: "160"
    },
    height: {
      type: String,
      default: "90"
    }
  },
  data: () => ({
    dialogFilePreview: false
  }),
  methods: {
    show() {
      if (this.src) {
        this.dialogFilePreview = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.image {
  cursor: pointer;
  &:hover {
    background-color: white !important;
  }
}
.image-container {
  width: 100%;
  height: 100%;
  max-height: 450px;
  overflow: auto;
}
</style>
